import { useContext } from 'react';

import { Box, Divider, Typography } from '@material-ui/core';
import { FiRefreshCw } from 'react-icons/fi';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { AppButton } from '@vyce/core/src/components/AppButton';
import { SettingsCard } from '@vyce/core/src/components/SettingsCard';
import { SafeDndProvider } from '@vyce/core/src/components/SafeDndProvider';

import { useStyles } from './styles';
import { useData } from './hooks';
import { Props } from './types';
import {
  FieldsFunctionsProvider,
  FieldsValuesProvider,
  FieldsFunctionsContext,
  LocationDetailBlock,
  TimeLogsDetailBlock,
  DetailedSummaryBlock,
} from './components';

/* 
  Module for Exporting Time Logs in T&A settings page
*/

const ExportColumns = () => {
  const classes = useStyles();
  const { restoreData } = useContext(FieldsFunctionsContext);

  return (
    <>
      <Typography variant="caption" className={classes.footnote}>
        Drag a column into the position you want it in the spreadsheet. Only ticked columns are included in
        the exported file, and your own location fields appear here once you add them above.
      </Typography>

      <Box display="flex" flexDirection="column" gridGap={16}>
        <SafeDndProvider backend={HTML5Backend}>
          <LocationDetailBlock />
          <Divider />
          <TimeLogsDetailBlock />
          <Divider />
          <DetailedSummaryBlock />
        </SafeDndProvider>
      </Box>

      <Box>
        <AppButton endIcon={<FiRefreshCw />} variant="outlined" color="primary" onClick={restoreData}>
          Restore to default
        </AppButton>
      </Box>
    </>
  );
};

export const ExportingTimeLogsModule = (props: Props) => {
  const { contextFunctionOptions, contextValuesOptions } = useData(props);

  return (
    <SettingsCard
      title="Time Log export — columns"
      description="Choose which columns land in your Time Log spreadsheet and the order they sit in. Untick anything your payroll doesn’t need."
      expanded={props.expanded}
      onExpandedChange={props.onExpandedChange}
    >
      <FieldsFunctionsProvider value={contextFunctionOptions}>
        <FieldsValuesProvider value={contextValuesOptions}>
          <ExportColumns />
        </FieldsValuesProvider>
      </FieldsFunctionsProvider>
    </SettingsCard>
  );
};
